import { z } from 'zod';

import {
    chatEventIdSchema,
    chatMessageIdSchema,
    chatThreadIdSchema,
    toolIdSchema,
} from '~/shared/data-contract/chat/chat-ids';

import { chatBlockListSchema } from './chat-blocks';

export const structuredResponsePayloadSchema = z.object({
    blocks: chatBlockListSchema,
});

export type StructuredResponsePayload = z.infer<typeof structuredResponsePayloadSchema>;

export const structuredResponseEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('structured-response'),
    messageId: chatMessageIdSchema,
    payload: structuredResponsePayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
    toolId: toolIdSchema,
});

export type StructuredResponseEvent = z.infer<typeof structuredResponseEventSchema>;
